import { render, staticRenderFns } from "./Faqr.vue?vue&type=template&id=0f76f808&"
import script from "./Faqr.vue?vue&type=script&lang=js&"
export * from "./Faqr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports